var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import React, { useContext } from 'react';
import styled, { css, ThemeContext } from 'styled-components';
import { defaultTextTheme } from './constants';
import textSizes from '../../constants/js/text-sizes.js';
import text from '../../constants/js/text.js';
import { textOverflowEllipsisBox } from '../../mixins/text/textOverflowEllipsisBox';
import { mergeTheme } from '../../utils/mergeTheme';
import { DATA_TEST } from '../../typings/data';
const TEXT_WEIGHT = {
  normal: text.textWeightRegular,
  medium: text.textWeightMedium,
  bold: text.textWeightBold
};
const StyledText = styled.div.withConfig({
  shouldForwardProp: (prop, defaultValidatorFn) => !['color'].includes(prop) && !['size'].includes(prop) && !['transform'].includes(prop) && defaultValidatorFn(prop)
}).withConfig({
  componentId: "Text__sc-vycpdy-0"
})(["", " ", " ", " ", " ", " ", " ", " ", ""], ({
  color,
  theme
}) => {
  var _a;

  return color && css(["color:", ";"], (_a = theme.Text) === null || _a === void 0 ? void 0 : _a.color[color]);
}, ({
  align
}) => align && css(["text-align:", ";"], align), ({
  verticalAlign
}) => verticalAlign && css(["vertical-align:", ";"], verticalAlign), ({
  weight
}) => weight && css(["font-weight:", ";"], TEXT_WEIGHT[weight]), ({
  size
}) => size && css(["font-size:", ";line-height:", ";"], textSizes[size].fontSize, textSizes[size].lineHeight), ({
  isNowrap
}) => isNowrap && css(["white-space:nowrap;"]), ({
  transform
}) => transform && ['lowercase', 'uppercase', 'capitalize', 'no-transform'].includes(transform) && css(["text-transform:", ";"], transform), ({
  transform
}) => transform === 'ellipsis' && textOverflowEllipsisBox);
const defaultProps = {
  tagName: 'div',
  [DATA_TEST]: 'text'
};
export const Text = _a => {
  var {
    tagName = defaultProps.tagName,
    dataTest = defaultProps.dataTest
  } = _a,
      otherProps = __rest(_a, ["tagName", "dataTest"]);

  const context = useContext(ThemeContext);
  const theme = mergeTheme(defaultTextTheme, context);
  return React.createElement(StyledText, Object.assign({
    as: tagName,
    "data-test": dataTest,
    theme: theme
  }, otherProps));
};